import { portalJson } from '../lib/portalApi';

/** POST /api/signup-requests — 백엔드 SignupIn 과 필드명 동일(camelCase) */
export type PortalSignupPayload = {
  userId: string;
  password: string;
  userName: string;
  position?: string | null;
  companyName: string;
  businessRegistrationNo: string;
  department?: string | null;
  jobTitle?: string | null;
  representativeName?: string | null;
  officePhone?: string | null;
  documentEmail?: string | null;
  phone: string;
  email: string;
  complexName: string;
  zonecode?: string | null;
  roadAddress: string;
  detailAddress?: string | null;
  product: string;
  memberType: string;
};

export type PortalSignupOk = { id: number; status: string };

export async function submitPortalSignup(
  payload: PortalSignupPayload
): Promise<PortalSignupOk> {
  const r = await portalJson<PortalSignupOk>('/api/signup-requests', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!r.ok) {
    throw new Error(r.message);
  }
  const d = r.data;
  if (typeof d.id !== 'number') {
    throw new Error('서버 응답 형식이 올바르지 않습니다.');
  }
  return d;
}
